// import $ from 'jquery'
import Accordion from '@scripts/modules/Accordion'


const infoAccordion = new Accordion({
    visible: '.technical-info .accordion__visible',
    collapse: '.technical-info .accordion__collapse',
    onlyOneOpened: true
})
